const soundMap = {
  x1: './sounds/1 Xylophone.mp3',
  x2: './sounds/2 Xylophone.mp3',
  x3: './sounds/3 Xylophone.mp3',
  x4: './sounds/4 Xylophone.mp3',
  x5: './sounds/5 Xylophone.mp3',
  x6:'./sounds/6 Xylophone.mp3',
  x7: './sounds/7 Xylophone.mp3',
  x8: './sounds/8 Xylophone.mp3',
x9:'./sounds/9 Xylophone.mp3',
b1: './sounds/1 Bass.mp3',
b2: './sounds/2 Bass.mp3',
b3: './sounds/3 Bass.mp3',
b4: './sounds/4 Bass.mp3',
b5: './sounds/5 Bass.mp3',
b6:'./sounds/6 Bass.mp3',
b7: './sounds/7 Bass.mp3',
b8: './sounds/8 Bass.mp3',
b9:'./sounds/9 Bass.mp3',
d1: './sounds/1 Drums.mp3',
d2: './sounds/2 Drums.mp3',
d3: './sounds/3 Drums.mp3',
d4: './sounds/4 Drums.mp3',
d5: './sounds/5 Drums.mp3',
d6:'./sounds/6 Drums.mp3',
d7: './sounds/7 Drums.mp3',
d8: './sounds/8 Drums.mp3',
d9:'./sounds/9 Drums.mp3',
a1: './sounds/1.mp3',
a2: './sounds/2.mp3',
a3: './sounds/3.mp3',
a4: './sounds/4.mp3',
a5: './sounds/5.mp3',
a6:'./sounds/6.mp3',
a7: './sounds/7.mp3',
a8: './sounds/8.mp3',
a9:'./sounds/10.mp3'
}

export default soundMap;
